import React, { useEffect, useState } from "react";
import { HiOutlineTrash, HiPencil, HiPlusSm } from "react-icons/hi";
import WorkerLeaveModal from "./WorkerLeaveModal";
import {  apiGetRequest } from "helpers/Requests";
import { convertTo12HourFormat, getNameProfile } from "Utils/utils";
import PaginationComponent from "components/common/Pagination";
import {
  emptyPaginationObj,
  POLICIES_LIST_LIMIT,
  USER_ROLE,
} from "Constants/constant";
import { getPaginationObj } from "Utils/utils";
import LeaveDeleteEmployeeModal from "./LeaveDeleteEmployeeModal";
import LeaveUpdateEmployeeModal from "./LeaveUpdateEmployeeModal";
import { roleAccess } from "helpers/RolesPermission";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import { parseISO, format } from "date-fns";

const WorkerLeaveEmployeeSettings = ({
  isUserGracePeriodOver,
  WorkerUuid,
  WorkerId,
  worker,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [leaves, setLeaves] = useState([]);
  const [isShowModal, setIsShowModal] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);

  const [selectedLeaveId, setSelectedLeaveId] = useState(null);
  const [paginationObj, setPaginationObj] = useState(emptyPaginationObj);
  const [page, setPage] = useState(1);

  const formatDisplayDate = (dateValue) => {
    if (!dateValue) return "N/A";
    try {
      return format(parseISO(dateValue), "dd-MMM-yyyy");
    } catch {
      return format(new Date(dateValue), "dd-MMM-yyyy");
    }
  };

  const fetchLeaves = async () => {
    try {
      setLoading(true);
      const response = await apiGetRequest(
        `/hrm/worker-leave?worker_uuid=${WorkerUuid}&page=${page}&per_page=${POLICIES_LIST_LIMIT}`
      );
      const pagePayload = response.data?.data;
      setLeaves(pagePayload?.data || []);
      setPaginationObj(getPaginationObj(pagePayload));
    } catch (error) {
      console.error("Error fetching worker leaves:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (WorkerUuid) {
      fetchLeaves();
    }
  }, [WorkerUuid, page]);

  return (
    <div>
      <label className='text-md font-bold'>Worker Leave</label>
      <div className='mt-1 mb-10'>
        <div className='flex justify-end text-blue-400 '>
          <div
            className='flex items-center cursor-pointer '
            onClick={() => setOpenModal(true)}
          >
            <span>
              <HiPlusSm />
            </span>
            <span className='text-sm font-semibold'>Add Leave Request</span>{" "}
          </div>
        </div>
        <div className='overflow-auto custom-scroll mt-1'>
          <table className='border border-collapse w-full'>
            <thead>
              <tr className='bg-[#e1e5f0]'>
                {roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager]) && (
                  <th className='border p-2'>Updated By</th>
                )}
                   <th className='border p-2'>Leave Type</th>
                <th className='border p-2'>Start Date</th>
                <th className='border p-2'>End Date</th>
                <th className='border p-2'>Reason</th>
                <th className='border p-2'>Comments</th>
                <th className='border p-2'>Status</th>
                <th className='border p-2'>Approval Date</th>
                <th className='border p-2'>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan={
                      roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager])
                        ? 9
                        : 8
                    }
                    className='text-center p-4'
                  >
                    <CircularLoader />
                  </td>
                </tr>
              ) : leaves.length > 0 ? (
                leaves.map((leave, index) => (
                  <tr key={index}>
                    {roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager]) && (
                      <td className='border p-2 text-xs align-middle'>
                        <div className='w-40 truncate capitalize text-sm'>
                          {leave?.updated_by}
                        </div>
                      </td>
                    )}
                    <td className='border p-2 text-sm text-center'>
                      {leave?.is_partial_leave ? "Partial" : "Full Day"}
                    </td>
                  <td className='border p-2 text-sm text-center'>
                      {new Date(leave.start_date).toLocaleDateString("en-AU")} {" "}
                      {leave.is_partial_leave ? `${convertTo12HourFormat(leave?.start_time)}` : ""}
                    </td>
                  <td className='border p-2 text-sm text-center'>
                      {new Date(leave.end_date).toLocaleDateString("en-AU")} {" "}
                       {leave.is_partial_leave ? `${convertTo12HourFormat(leave?.end_time)}` : ""}
                    </td>
                    <td className='border p-2 text-sm max-w-xs'>
                      <div
                        className='truncate-3-lines break-words'
                        title={leave.details}
                      >
                        {leave.details || "N/A"}
                      </div>
                    </td>
                    <td className='border p-2 text-sm max-w-xs'>
                      <div
                        className='truncate-3-lines break-words'
                        title={leave.rejection_notes}
                      >
                        {leave.rejection_notes || "N/A"}
                      </div>
                    </td>

                    <td className='border p-2 text-center text-sm'>
                      {(() => {
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);

                        const endDate = new Date(leave.end_date);
                        endDate.setHours(0, 0, 0, 0);

                        let displayStatus = leave.status || "-";
                        const baseClass =
                          "inline-flex items-center px-2 py-1 rounded text-sm font-semibold capitalize";
                        let styleClass = "bg-gray-100 text-gray-700";

                        if (leave.status?.toLowerCase() === "approved") {
                          displayStatus = "Approved";
                          styleClass = "bg-green-100 text-green-700";
                        } else if (leave.status?.toLowerCase() === "rejected") {
                          displayStatus = "Rejected";
                          styleClass = "bg-red-100 text-red-700";
                        } else if (leave.status?.toLowerCase() === "expired") {
                          displayStatus = "Expired";
                          styleClass = "bg-red-100 text-red-700";
                        } else if (leave.status?.toLowerCase() === "pending") {
                          if (endDate < today) {
                            displayStatus = "Expired";
                            styleClass = "bg-red-100 text-red-700";
                          } else {
                            displayStatus = "Pending";
                            styleClass = "bg-yellow-100 text-yellow-700";
                          }
                        }

                        return (
                          <span className={`${baseClass} ${styleClass}`}>
                            {displayStatus}
                          </span>
                        );
                      })()}
                    </td>

                    <td className='border p-2 text-sm text-center'>
                      {leave.status?.toLowerCase() === "approved" && leave.approval_date
                        ? formatDisplayDate(leave.approval_date)
                        : "N/A"}
                    </td>

                    <td className='border p-2 text-center text-xs'>
                      <div className='flex justify-center gap-x-2'>
                        {(() => {
                          // compute once per row
                          const today = new Date();
                          today.setHours(0, 0, 0, 0);

                          const endDate = leave.end_date
                            ? new Date(leave.end_date)
                            : null;
                          if (endDate) endDate.setHours(0, 0, 0, 0);

                          const isPending =
                            leave.status?.toLowerCase() === "pending";
                          const isExpired =
                            isPending && endDate && endDate < today;

                          return (
                            <>
                              {/* Pending & NOT expired -> show Edit AND Delete */}
                              {isPending && !isExpired && (
                                <>
                                  <button
                                    type='button'
                                    onClick={() => {
                                      setSelectedLeaveId(leave.uuid);
                                      setIsOpenModal(true);
                                    }}
                                    className='icon-pencil-wrapper'
                                    title='Edit'
                                  >
                                    <HiPencil className='icon-size' />
                                  </button>

                                  <button
                                    type='button'
                                    onClick={() => {
                                      setSelectedLeaveId(leave.uuid);
                                      setIsShowModal(true);
                                    }}
                                    className='icon-delete-wrapper'
                                    title='Delete'
                                  >
                                    <HiOutlineTrash className='icon-size' />
                                  </button>
                                </>
                              )}

                              {isPending && isExpired && (
                                <button
                                  type='button'
                                  onClick={() => {
                                    setSelectedLeaveId(leave.uuid);
                                    setIsShowModal(true);
                                  }}
                                  className='icon-delete-wrapper'
                                  title='Delete'
                                >
                                  <HiOutlineTrash className='icon-size' />
                                </button>
                              )}
                            </>
                          );
                        })()}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={
                      roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager])
                        ? 9
                        : 8
                    }
                    className='text-center p-2 text-red-600 text-xs'
                  >
                    No leave requests found!
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {(paginationObj.total > POLICIES_LIST_LIMIT ||
        paginationObj.totalPages > 1) && (
        <div className='px-6 bg-white mt-5 pb-10'>
          <PaginationComponent
            page={page}
            activeListLength={leaves || []}
            limit={POLICIES_LIST_LIMIT}
            totalList={paginationObj.total}
            handlePagination={(nextPage) => {
              setPage(nextPage);
            }}
            totalPages={paginationObj.totalPages}
          />
        </div>
      )}
      {openModal && (
        <WorkerLeaveModal
          isUserGracePeriodOver={isUserGracePeriodOver}
          openModal={openModal}
          handleClose={setOpenModal}
          WorkerId={WorkerId}
          onLeaveAdded={fetchLeaves}
          apiType='hrm'
        />
      )}
      {isShowModal && (
        <LeaveDeleteEmployeeModal
          isUserGracePeriodOver={isUserGracePeriodOver}
          isShow={isShowModal}
          handleClose={() => setIsShowModal(false)}
          leaveId={selectedLeaveId}
          workerUuid={WorkerUuid}
          onDeleted={fetchLeaves}
        />
      )}
      {isOpenModal && (
        <LeaveUpdateEmployeeModal
          isUserGracePeriodOver={isUserGracePeriodOver}
          isOpen={isOpenModal}
          handleClose={() => setIsOpenModal(false)}
          leaveId={selectedLeaveId}
          workerUuid={WorkerUuid}
          onLeaveUpdated={fetchLeaves}
          leaveData={leaves.find((l) => l.uuid === selectedLeaveId)}
        />
      )}
    </div>
  );
};
export default WorkerLeaveEmployeeSettings;
